import '@babel/polyfill';
import $ from 'jquery';
// import imagesLoaded from 'imagesloaded';
import {TweenLite, TimelineMax } from "gsap";

function pageIntro() {
    // Preloader
    const playPreloader = () => {
        let loadedCount = 0; 
        const imagesNode = document.querySelectorAll('.bcg-section');
        const imagesToLoadArray = Array.from(imagesNode);
        let imagesToLoad = imagesToLoadArray.length - 1;
        let loadingProgress = 0; 
        let body = $('body');

        let imagesObject = Object.assign({}, imagesToLoadArray);
            imagesLoaded(body, { background: imagesObject }).on( 'progress', function() {
                loadProgress();
            });
        
            function loadProgress(imgLoad, image) {
                loadedCount++;
                loadingProgress = (loadedCount/imagesToLoad);
                TweenLite.to(progressTl, 1.2, {progress:loadingProgress, ease:Linear.easeNone});
            }
        
            var progressTl = new TimelineMax({paused:true,onUpdate:progressUpdate,onComplete:loadComplete});
            progressTl
                .to($('.progress span'), 1, {width:100, ease:Linear.easeNone});
        
            function progressUpdate()
            {
                loadingProgress = Math.round(progressTl.progress() * 100);
                $(".txt-perc").text(loadingProgress + '%');
            }
        
            function loadComplete() {
        
                // preloader out
                var preloaderOutTl = new TimelineMax();
        
                preloaderOutTl
                    .to($('.progress'), 0.3, {y: 100, autoAlpha: 0, ease:Back.easeIn})
                    .to($('.txt-perc'), 0.3, {y: -100, autoAlpha: 0, ease:Back.easeIn}, 0.1)
                    .set($('body'), {className: '-=is-loading'})
                    .set($('#intro'), {className: '+=is-loaded'})
                    .to($('#preloader'), 0.7, {yPercent: 100, ease:Power4.easeInOut})
                    .set($('#preloader'), {className: '+=is-hidden'})
                    .from($('#intro .title'), 1, {autoAlpha: 0, ease:Power1.easeOut}, '-=0.1')
                    .from($('#intro p'), 0.7, {autoAlpha: 0, ease:Power1.easeOut}, '+=0.1')
                    
                return preloaderOutTl;
            }
        } // End of function


    playPreloader();

    // Header
    const introTopHeader = () => {
        const pageHeader = document.querySelector('.header-top');
        pageHeader.classList.add('header-visible');
    }
    introTopHeader();
}

export default pageIntro;